import React, {useContext, useEffect, useState} from 'react';
import { useParams, useHistory } from 'react-router-dom';
import EnhancedTable from '../components/EnhancedTable';
import { getData } from '../utils/apiUtils';
import { ErrorContext } from "../utils/constants";

const changeLogCells = [
  { id: 'modify_user', numeric: false, label: 'Modified By' },
  { id: 'date', numeric: false, label: 'Date', format: 'datetime' },
  { id: 'entity', numeric: false, label: 'Entity' },
  { id: 'name', numeric: false, label: 'Name' },
  { id: 'column', numeric: false, label: 'Column' },
  { id: 'old_value', numeric: false, label: 'Old Value' },
  { id: 'new_value', numeric: false, label: 'New Value' }
];

export default function ChangeLog()  {
  const params = useParams();
  const [ currentChangeLog, setCurrentChangeLog ] = useState([]);
  const { triggerError } = useContext(ErrorContext);
  const history = useHistory();

  useEffect(() => {
    document.title = 'Rise by TransAlta Change Log';
  }, []);
  const onError = (error) => {
    if (error.status === 404) {
      history.push('/ui/errors/error404');
      return;
    }
    triggerError({
      title: 'Communication Error',
      description: 'We were unable to read the change logs from the server. Please try again.',
      onRetry: () => window.location.reload(),
    });
  }

  const fetchData = () => {
    getData(`/initiatives/${params.id}/change-log`, setCurrentChangeLog, onError);
  };

  const changeLogRowClick = (e, row) => {
    let url = '';
    switch (row['entity'].toLowerCase()) {
      case 'attachment':
      case 'comment':
      case 'initiative':
      case 'metric_year':
      case 'tag':
        url = '/ui/initiativecard/';
        break;
      case 'kpi':
        url = '/ui/initiativecard/kpis/';
        break;
      case 'milestone':
        url = '/ui/initiativemilestones/';
        break;
      case 'value':
        url = '/ui/initiativevalues/';
        break;
      case 'initiative_user':
        url = '/ui/initiativedetails/';
        break;
      default:
        url = '';
    }

    url && history.push(url + row['initiative_id']);
  };

  useEffect(fetchData, []);

  return (
    <div>
      <h2>Change Log for Initiative #{params.id}</h2>
      <div>Listing {currentChangeLog.length} change log items.</div>
      <EnhancedTable id={`1f974da4-10cc-4d8a-ab47-3cb571eb3354-${params.id}`}
                     headCells={changeLogCells}
                     rows={currentChangeLog}
                     allowExport={true}
                     exportFilename="Change Log"
                     rowsPerPage={25}
                     rowsPerPageOptions={[10,25,50,100]}
                     onClick={changeLogRowClick} />
    </div>
  );
}
